'use client';

import { FC, PropsWithChildren } from 'react';
import { InvoicesProvider } from './_context/InvoicesContext';

const InvoicesLayout: FC<PropsWithChildren<unknown>> = ({ children }) => (
  <InvoicesProvider>{children}</InvoicesProvider>
);

export default InvoicesLayout;
